// extracted by mini-css-extract-plugin
export default {"overlayClassName":"overlayClassName___dae9e19237b14310","notificationModal":"notificationModal___daa1ac4bb0bfdf7e","modal":"modal___e48f60982676c3e8"};